import { useCallback } from 'react';
import { useLoaderData, useNavigate } from 'react-router';
import type { LoaderFunctionArgs } from 'react-router';

import { BrainApp } from './brain/BrainApp';

export interface CargaDoBrain {
    /** A conversa do endereço (`?conversa=`), para voltar a ela ao recarregar. */
    conversaId: string | null;
}

export async function carregarBrain({ request }: LoaderFunctionArgs): Promise<CargaDoBrain> {
    return { conversaId: new URL(request.url).searchParams.get('conversa') };
}

/**
 * Brain em tela cheia — a tela do Brain original dentro da shell da clínica
 * (trilha B5). Conversas, projetos e preferências são lidos pela própria tela,
 * como no original, para a mesma tela servir ao painel à direita.
 */
export function Brain() {
    const carga = useLoaderData() as CargaDoBrain;
    const navigate = useNavigate();
    const aoMudarConversa = useCallback((id: string | null) => {
        navigate(id ? `/app/brain?conversa=${encodeURIComponent(id)}` : '/app/brain', { replace: true });
    }, [navigate]);
    return (
        <div className="brain-pagina">
            {/* Recarregar numa conversa aberta volta a ela; a voz começaria outra. */}
            <BrainApp conversaInicial={carga.conversaId} aoMudarConversa={aoMudarConversa} abrirNaVoz={!carga.conversaId} />
        </div>
    );
}
